import Tool from './utils.js'
// import $store from '@/store/index.js'

let instance = null
let _billingInitMsg = null
let _loaded = false
// let disable = false
/**
 * 初始化计费系统
 * @param {Object} data - 传入的数据对象，本函数未使用该参数
 */
function initBilling (data) {
  let { billingBackedUrl, billingFrontUrl } = data
  // disable = disableBilling
  // if (disableBilling) return
  // billingBackedUrl = 'cc-ms-kry.tvunetworks.com:8081/route-billing/billing-service/'
  // billingFrontUrl = 'cc-ms-kry.tvunetworks.com:8081'
  // https://cc-ms-kry.tvunetworks.com:8081/js/billing.js
  const url =
    document.location.protocol + '//' + billingFrontUrl + '/js/billing.js'
  Tool.dynamicLoadJs(url, () => {
    handleBillingJs(billingBackedUrl)
  })
  // if (BillingIframe) {
}

function handleBillingJs (billingBackedUrl) {
  if (!window.BillingIframe) {
    return setTimeout(() => {
      handleBillingJs(billingBackedUrl)
    }, 1000)
  }
  const params = {
    url: billingBackedUrl,
    product: 'Mediahub',
    session: ''
  }
  instance = new window.BillingIframe(params, (billingInitMsg) => {
    _billingInitMsg = billingInitMsg
    _loaded = true
  })
  // $store.commit('saveBillingInstance', billingInstance)
}
function toggleLanguage (language) {
  instance && typeof instance.changeLaguage == 'function' &&
    instance.changeLaguage(language)
}
function manageBilling () {
  instance && typeof instance.manageMediaHubBill == 'function' &&
    instance.manageMediaHubBill({ action: 'manage' })
}
function activeNode (data = {}) {
  instance && typeof instance.manageMediaHubBill == 'function' &&
    instance.manageMediaHubBill({
      action: 'charge',
      nodeType: 'node',
      core: data.core
    })
}

function cloudCharge (data, callback) {
  // if (disable) return runFun(callback.success)
  const chargeItems = []
  const { format, destlow, desthigh, email, input } = data
  if (input) {
    chargeItems.push({
      id: 'mh_source_number',
      increase: input
    })
  }
  if (format) {
    chargeItems.push({
      id: 'mh_format_number',
      increase: format
    })
  }
  if (destlow) {
    chargeItems.push({
      id: 'mh_destlow_number',
      increase: destlow
    })
  }
  if (desthigh) {
    chargeItems.push({
      id: 'mh_desthigh_number',
      increase: desthigh
    })
  }
  const queryParams = {
    chargeItems: JSON.stringify(chargeItems),
    useOdoo: true,
    customerId: email,
    product: 'Mediahub'
  }
  const params = {
    type: 'charge', // charge | manage 区分是那种方式
    queryParams
  }
  mediaHubCharge(params, { nodeType: 'cloud' }, callback)
}

function nodeCharge (data, callback = {}) {
  // if (disable) return runFun(callback.success)
  const core = data.core
  const queryParams = {
    chargeItems: `[{"id": "mh_plan_core_number","increase": ${core}}]`,
    useOdoo: true,
    customerId: data.email,
    product: 'Mediahub'
  }
  const params = {
    type: 'charge', // charge | manage 区分是那种方式
    queryParams
  }
  mediaHubCharge(
    params,
    { nodeType: 'node', core: Math.ceil(core / 4) },
    callback
  )
}

function mediaHubCharge (params, openData, callback = {}) {
  if (!_loaded) {
    return setTimeout(() => {
      mediaHubCharge(params, openData, callback)
    }, 300)
  }
  instance && instance.handlePermission(params, {
    close: (e) => {
      // console.log(e)
      // 支付之后的关闭后再去看一下状态
      if (e && e.checkOut) {
        // queryPermission(params.queryParams, callback)
        mediaHubCharge(params, openData, callback)
      } else {
        runFun(callback.close)
      }
    },
    success: (e) => {
      // console.log('%cSuccess:', 'color: red; font-weight: bold', e)
      if (typeof callback.success === 'function') {
        callback.success(e)
      }
    },
    error: (e) => {
      // console.log(e)
      runFun(callback.close)
    },
    iframeData: () => {
      return openData
    }
  })
}

// function queryPermission (params, callback) {
//   instance && instance.queryPermission(params).then((data) => {
//     if (data && data.permission && data.permission.code == '0x0') {
//       callback.success()
//     } else {
//       runFun(callback.close)
//     }
//   }).catch(() => {})
// }

function runFun (fn) {
  if (typeof fn === 'function') fn()
}

function getInstance () {
  return instance
}

function postPayStatus (params) {
  if (instance && typeof instance.postPayStatus === 'function') {
    return instance.postPayStatus(params)
  } else {
    return Promise.resolve()
  }
}

function whiteListInfo (params) {
  if (instance && typeof instance.whiteListInfo === 'function') {
    return instance.whiteListInfo(params)
  } else {
    return Promise.resolve()
  }
}

export default {
  initBilling,
  manageBilling,
  cloudCharge,
  nodeCharge,
  getInstance,
  toggleLanguage,
  activeNode,
  postPayStatus,
  whiteListInfo,
  get instance () {
    return instance
  },
  get loaded () {
    return _loaded
  },
  get billingInitMsg () {
    return _billingInitMsg
  }
}
